import { render, staticRenderFns } from "./DetailsDrawer.vue?vue&type=template&id=6c0fdf3d"
import script from "./DetailsDrawer.vue?vue&type=script&lang=js"
export * from "./DetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "../../assets/detailsDrawer.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports